import axios from "axios";
import { useState, useEffect } from "react";
import Swal from "sweetalert2";
import Cookies from "js-cookie";
import ImagesUpload from "../forms/ImagesUpload";
import localforage from "localforage";
import { Link } from "react-router-dom";
import { Phone, AlignLeft, Send, MessageCircle, BadgeHelp } from "lucide-react";
import { FormSection, FormInput, FormButton } from "../forms/shared/FormComponents";

const dbName = "DataHelpPostperty";
localforage.config({
    name: dbName,
    storeName: "DataHelpPostperty",
    description: "Store_Data",
});

const HelpSellPostperty = () => {
    const [textCheckPhoneNumber, setTextCheckPhoneNumber] = useState("กรุณากรอกเบอร์โทรศัพท์ 10 หลัก");

    const checkPhoneNumber = (number) => {
        if (number.length > 10) {
            setTextCheckPhoneNumber("กรุณาระบุเบอร์โทรแค่ 10หลัก");
        }
        if (number !== "" && number.length === 10) {
            axios
                .get(`${process.env.REACT_APP_API}/event/checkExistedlead/${number}`)
                .then(() => {})
                .catch(() => {});
        }
    };

    const [upload, setUpload] = useState({ phone_number: "", description: "", images: [] });
    const { description, images } = upload;

    useEffect(() => {
        const storeUploadData = async () => {
            try {
                await localforage.setItem("HelpSellPostPerty", upload);
            } catch (err) {
                console.error("Error storing upload data", err);
            }
        };
        storeUploadData();
    }, [upload]);

    useEffect(() => {
        const retrieveUploadData = async () => {
            try {
                const savedUploadData = await localforage.getItem("HelpSellPostPerty");
                if (savedUploadData) setUpload(savedUploadData);
            } catch (err) {
                console.error("Error retrieving upload data", err);
            }
        };
        retrieveUploadData();
    }, []);

    const handleRemoveDataInIndexedDB = () => {
        localforage.dropInstance({ name: dbName }).catch((err) => {
            console.error(`Error removing database: ${dbName}`, err);
        });
    };

    const inputValue = (name) => (e) => {
        setUpload({ ...upload, [name]: e.target.value });
    };

    const [lengthOfDetailPost, setLengthOfDetailPost] = useState(0);
    const handleDetailPostLimit = (e) => {
        const lengthOfDetail = e.target.value.length;
        const textOfDetail = e.target.value;
        if (lengthOfDetail <= 999) {
            setLengthOfDetailPost(lengthOfDetail);
            setUpload((prev) => ({ ...prev, description: textOfDetail }));
        } else {
            Swal.fire({
                icon: "error",
                title: "เกินจำนวนตัวอักษรที่กำหนด",
                text: "คุณสามารถกรอกข้อความได้สูงสุด 1000 ตัวอักษร",
                showConfirmButton: false,
                timer: 1500,
            });
        }
    };

    const [pageNumber, setPageNumber] = useState(1);

    const [isUploading, setIsUploading] = useState(false);
    const handleHelpSellPostpertyendToDashboardAdmin = () => {
        setIsUploading(true);
        const token = Cookies.get("jwt");
        axios
            .post(
                `${process.env.REACT_APP_API}/asset/post/postperty-handle-asset`,
                {
                    phone_number: upload.phone_number,
                    description: upload.description,
                    images: upload.images,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "multipart/form-data",
                    },
                }
            )
            .then(async () => {
                handleRemoveDataInIndexedDB();
                await Swal.fire("ส่งข้อมูลสำเร็จ", "", "success");
                window.location.replace("/home");
                setIsUploading(false);
            })
            .catch((err) => {
                setIsUploading(false);
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: `${err.response.data.Error}`,
                });
            });
    };

    const phoneTextColor =
        textCheckPhoneNumber === "กรุณากรอกเบอร์โทรศัพท์ 10 หลัก"
            ? "text-gray-400"
            : textCheckPhoneNumber.startsWith("เบอร์โทรนี้ไม่ได้เป็นสมาชิก")
            ? "text-green-500"
            : "text-red-500";

    return (
        <div className="min-h-screen bg-gray-50">
            <div className="w-full max-w-xl mx-auto px-4 pb-24">

                {/* Header */}
                <div className="pt-6 pb-4">
                    <div className="flex items-center gap-2">
                        <BadgeHelp size={22} className="text-postperty" />
                        <h1 className="text-lg font-semibold text-gray-800">ติดต่อ PostPerty</h1>
                    </div>
                    <p className="text-xs text-gray-400 mt-0.5">ส่งข้อมูลทรัพย์ให้เราช่วยดูแลและขายให้คุณ</p>
                </div>

                {/* Quick contact buttons */}
                <div className="grid grid-cols-2 gap-3 mb-4">
                    <Link
                        to="https://line.me/ti/p/%40postperty"
                        target="_blank"
                        className="h-12 flex justify-center items-center gap-2 rounded-xl bg-green-400 text-white text-sm font-medium shadow-sm hover:opacity-90 transition-opacity"
                    >
                        <MessageCircle size={16} />
                        Line OA
                    </Link>
                    <a
                        href="tel:02-123-3632"
                        className="h-12 flex justify-center items-center gap-2 rounded-xl bg-postperty text-white text-sm font-medium shadow-sm hover:opacity-90 transition-opacity"
                    >
                        <Phone size={16} />
                        โทรหาเรา
                    </a>
                </div>

                <div className={pageNumber === 1 ? "flex flex-col gap-4" : "hidden"}>

                    {/* Phone number */}
                    <FormSection title="เบอร์โทรศัพท์ของคุณ">
                        <div className="relative">
                            <Phone size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                            <FormInput
                                type="text"
                                defaultValue={upload.phone_number}
                                placeholder="0812345678"
                                className="pl-9"
                                onChange={(e) => {
                                    inputValue("phone_number")(e);
                                    checkPhoneNumber(e.target.value);
                                }}
                            />
                        </div>
                        <p className={`mt-2 text-xs ${phoneTextColor}`}>
                            {textCheckPhoneNumber}
                        </p>
                    </FormSection>

                    {/* Images */}
                    <FormSection title="รูปภาพทรัพย์">
                        <ImagesUpload
                            images={images}
                            upload={upload}
                            setUpload={setUpload}
                            setPageNumber={setPageNumber}
                        />
                    </FormSection>

                    {/* Description */}
                    <FormSection title={`รายละเอียด (${lengthOfDetailPost}/999)`}>
                        <div className="relative">
                            <AlignLeft size={15} className="absolute left-3 top-3 text-gray-400" />
                            <textarea
                                defaultValue={description}
                                onChange={handleDetailPostLimit}
                                placeholder="อธิบายรายละเอียดทรัพย์ ทำเล สภาพแวดล้อม..."
                                className="w-full h-40 bg-gray-50 rounded-xl pl-9 pr-3 pt-3 pb-3 text-sm outline-none border border-gray-100 focus:border-postperty transition-colors resize-none"
                            />
                        </div>
                    </FormSection>

                    {/* Staff contact */}
                    <a
                        href="tel:02-123-3632"
                        className="w-full h-12 flex justify-center items-center gap-2 rounded-xl border border-gray-200 bg-white text-sm text-gray-600 hover:border-postperty hover:text-postperty transition-colors shadow-sm"
                    >
                        <Phone size={15} />
                        ติดต่อเจ้าหน้าที่ทันที
                    </a>

                    {/* Submit */}
                    <FormButton onClick={handleHelpSellPostpertyendToDashboardAdmin} disabled={isUploading}>
                        {isUploading ? (
                            "กำลังอัพโหลด..."
                        ) : (
                            <>
                                <Send size={15} />
                                ส่งข้อมูลให้ PostPerty
                            </>
                        )}
                    </FormButton>

                </div>
            </div>
        </div>
    );
};

export default HelpSellPostperty;
